import { Layout, Header } from '@kanda-libs/ks-design-library';

import { Content } from '../components';

const ViewComponent = ({}) => (
  <Layout noBorder header={<Header.Base lines />} footer={undefined}>
    <Content />
  </Layout>
);

ViewComponent.displayName = 'Expired-Mobile-view';

export default ViewComponent;
